/*
 * safety-cover-cart.js
 * The cart half of the safety cover builder.
 *
 * WHAT IS LEFT IN HERE
 * --------------------
 * Two helpers, and nothing else: which cart surfaces this theme has on the page, and how
 * to hand a cart response back to them. The builder posts its own request to /cart/add.js
 * because the theme's <product-form> is bound to the plain cover product and the variant
 * being sold may belong to its with-cutout twin. Everything AFTER that request — the
 * section list, renderContents on the drawer / cart / notification — is the theme's own,
 * asked for by its own code, so an add refreshes exactly what it refreshes everywhere
 * else on the store.
 *
 * WHAT USED TO BE IN HERE, AND WHY IT IS GONE
 * -------------------------------------------
 * Until 2026-08-27 the step cutout was a separate one-variant product added as a SECOND
 * cart line beside the cover. The two lines were tied together by a shared
 * properties[_cover_group], and this file swept the cart on every change to remove a
 * cutout whose cover had been taken out — otherwise a shopper could check out paying for
 * a cutout in nothing. It had to load on every page of the store, because a cover can be
 * removed from the cart drawer anywhere, and it still could not cover a cart edited at
 * checkout, on another device, or with scripting off.
 *
 * The cutout is now a second cover product rather than a companion line. One line item
 * cannot be half-removed, so there is nothing left to guard, nothing to keep in sync, and
 * no reason for this file to load anywhere but the safety cover page. The section it was
 * loaded from in sections/footer-group.json has been removed with it.
 */
(function () {
  'use strict';

  if (window.SafetyCoverCart) return;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Whichever cart surfaces this theme has on the page, asked for by their own code, so an
  // add refreshes exactly what it refreshes everywhere else on the store.
  function sections() {
    var out = [];
    var drawer = document.querySelector('cart-drawer');
    var items = document.querySelector('cart-items');
    var note = document.querySelector('cart-notification');
    if (drawer && drawer.getSectionsToRender) {
      out = out.concat(drawer.getSectionsToRender().map(function (s) { return s.id; }));
    }
    if (note && note.getSectionsToRender) {
      if (window.loadTemplateContent) window.loadTemplateContent(note);
      out = out.concat(note.getSectionsToRender().map(function (s) { return s.id; }));
    }
    if (items && items.getSectionsToRender) {
      out = out.concat(items.getSectionsToRender().map(function (s) { return s.section; }));
    }
    var seen = {};
    return out.filter(function (id) {
      if (!id || seen[id]) return false;
      seen[id] = 1;
      return true;
    });
  }

  function render(data) {
    var drawer = document.querySelector('cart-drawer');
    var items = document.querySelector('cart-items');
    var note = document.querySelector('cart-notification');
    if (drawer && drawer.renderContents) {
      drawer.renderContents(data);
      drawer.classList.remove('is-empty');
    }
    if (items && items.renderContents) items.renderContents(data);
    if (note && note.renderContents) {
      note.renderContents(data);
      note.classList.remove('is-empty');
    }
  }

  window.SafetyCoverCart = { sections: sections, render: render, root: root };
})();
